import {GetRefundBeneficiaries} from 'domain/usecases';
import {makeBFFApiUrl} from 'main/factories/http';

import {RemoteRefundGetBeneficiaries} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';

import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundBeneficiaries = (): GetRefundBeneficiaries =>
	new RemoteRefundGetBeneficiaries(
		makeBFFApiUrl(RefundFlowEndPoints.beneficiaries),
		makeAuthorizeHttpClientDecorator(),
	);
